var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicOffSm = function SvgMicOffSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mic-off-sm_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1 6.5a.937.937 0 0 0-1.1.8 6.13 6.13 0 0 1-5.112 5.119L7 15.062V16.5h2v-2.1a7.956 7.956 0 0 0 6.9-6.8.99.99 0 0 0-.8-1.1M6.52 12.293A5.91 5.91 0 0 1 2.1 7.4a1.033 1.033 0 0 0-1.2-.9.99.99 0 0 0-.8 1.1 7.98 7.98 0 0 0 5.23 6.357zM7.814 10.481 12 4.621V4.5a4 4 0 1 0-8 0v2a4 4 0 0 0 3.814 3.981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5a1 1 0 0 1-.813-1.581l10-14a1 1 0 1 1 1.628 1.162l-10 14A1 1 0 0 1 3 16.5"
  }))));
};
export default SvgMicOffSm;